let tempCounter = 0;
const buildTempId = () => `temp-estudiante-${tempCounter++}`;

const toDateOnly = (value) => {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toISOString().split("T")[0];
};

const normalizeEducacionHistorial = (historial = []) => {
  if (!Array.isArray(historial)) return [];
  return historial.map((item, index) => ({
    id: item.id ?? `temp-edu-${index}`,
    estudianteId: item.estudiante_id ?? null,
    nivelEstudio: item.nivel_estudio || "",
    institucion: item.institucion || "",
    tituloObtenido: item.titulo_obtenido || "",
    createdAt: item.created_at || null,
    updatedAt: item.updated_at || null,
  }));
};

const normalizeExperienciaHistorial = (historial = []) => {
  if (!Array.isArray(historial)) return [];
  return historial.map((item, index) => ({
    id: item.id ?? `temp-exp-${index}`,
    estudianteId: item.estudiante_id ?? null,
    empresaId: item.empresa_id ?? null,
    cargo: item.cargo || "",
    fechaInicio: toDateOnly(item.fecha_inicio || ""),
    fechaFin: toDateOnly(item.fecha_fin || ""),
    actualmenteTrabaja:
      item.actualmente_trabaja === 1 ||
      item.actualmente_trabaja === "1" ||
      item.actualmente_trabaja === true,
    tipoContrato: item.tipo_contrato || "",
    descripcion: item.descripcion || "",
    createdAt: item.created_at || null,
    updatedAt: item.updated_at || null,
  }));
};

export const normalizeEstudiante = (estudiante = {}, fallbackId) => ({
  id: estudiante.id ?? fallbackId ?? buildTempId(),
  nombres: (estudiante.nombres || "").trim(),
  apellidos: (estudiante.apellidos || "").trim(),
  documento: estudiante.documento_identidad || estudiante.documento || "",
  telefono: estudiante.celular || estudiante.telefono || "",
  telefonoFijo: estudiante.telefono_fijo || "",
  contactoEmergenciaNombre: estudiante.contacto_emergencia_nombre || "",
  contactoEmergenciaTelefono: estudiante.contacto_emergencia_telefono || "",
  email: estudiante.email || "",
  estadoAcademico: estudiante.estado_academico || estudiante.estadoAcademico || "preinscrito",
  activo:
    typeof estudiante.activo === "boolean"
      ? estudiante.activo
      : estudiante.activo === 1 || estudiante.activo === "1",
  interesadoId: estudiante.interesado_id ?? estudiante.interesadoId ?? null,
  referenteId: estudiante.referente_id ?? estudiante.referenteId ?? null,
  referenteNombre: estudiante.referente_nombre || estudiante.referenteNombre || null,
  referenteTipo: estudiante.referente_tipo || estudiante.referenteTipo || null,
  centroId: estudiante.centro_id ?? estudiante.centroId ?? null,
  creadoEl: estudiante.created_at || estudiante.creadoEl || null,
  nacionalidad: estudiante.nacionalidad || "",
  fechaNacimiento: toDateOnly(estudiante.fecha_nacimiento || estudiante.fechaNacimiento || ""),
  sexo: estudiante.sexo || "",
  estadoCivil: estudiante.estado_civil || "",
  tipoSangre: estudiante.tipo_sangre || "",
  estatura: estudiante.estatura ?? "",
  peso: estudiante.peso ?? "",
  tatuaje: estudiante.tatuaje || "",
  celularSecundario: estudiante.celular_secundario || "",
  parentescoSecundario: estudiante.parentesco_secundario || estudiante.parentescoSecundario || "",
  nivelEstudio: estudiante.nivel_estudio || estudiante.nivelEstudio || "",
  institucion: estudiante.institucion || "",
  tituloObtenido: estudiante.titulo_obtenido || "",
  pais: estudiante.pais || "",
  provincia: estudiante.provincia || "",
  canton: estudiante.canton || "",
  parroquia: estudiante.parroquia || "",
  direccion: estudiante.direccion || "",
  codigoPostal: estudiante.codigo_postal || "",
  movilizacion: estudiante.movilizacion === undefined ? null : estudiante.movilizacion === 1 || estudiante.movilizacion === "1" || estudiante.movilizacion === true,
  // Un estudiante puede tener varios vehículos/licencias — listas propias
  // (estudiantes_vehiculos / estudiantes_licencias), ya no un solo valor.
  vehiculos: Array.isArray(estudiante.vehiculos) ? estudiante.vehiculos : [],
  licencias: Array.isArray(estudiante.licencias) ? estudiante.licencias : [],
  dispViajar: estudiante.disp_viajar === undefined ? null : estudiante.disp_viajar === 1 || estudiante.disp_viajar === "1" || estudiante.disp_viajar === true,
  dispTurnos: estudiante.disp_turnos === undefined ? null : estudiante.disp_turnos === 1 || estudiante.disp_turnos === "1" || estudiante.disp_turnos === true,
  dispFinesSemana: estudiante.disp_fines_semana === undefined ? null : estudiante.disp_fines_semana === 1 || estudiante.disp_fines_semana === "1" || estudiante.disp_fines_semana === true,
  experienciaAnios: estudiante.experiencia_anios ?? "",
  experienciaId: estudiante.experiencia_id ?? null,
  experienciaEmpresaId: estudiante.experiencia_empresa_id ?? null,
  experienciaCargo: estudiante.experiencia_cargo || "",
  experienciaFechaInicio: toDateOnly(estudiante.experiencia_fecha_inicio || ""),
  experienciaFechaFin: toDateOnly(estudiante.experiencia_fecha_fin || ""),
  experienciaActualmenteTrabaja:
    estudiante.experiencia_actualmente_trabaja === undefined
      ? null
      : estudiante.experiencia_actualmente_trabaja === 1 ||
        estudiante.experiencia_actualmente_trabaja === "1" ||
        estudiante.experiencia_actualmente_trabaja === true,
  experienciaTipoContrato: estudiante.experiencia_tipo_contrato || "",
  experienciaDescripcion: estudiante.experiencia_descripcion || "",
  experienciaProvincia: estudiante.experiencia_provincia || "",
  experienciaCanton: estudiante.experiencia_canton || "",
  contificoPersonaId: estudiante.contifico_persona_id || null,
  libretaMilitar: estudiante.libreta_militar === 1 || estudiante.libreta_militar === "1" || estudiante.libreta_militar === true,
  consejoJudicatura: estudiante.consejo_judicatura === 1 || estudiante.consejo_judicatura === "1" || estudiante.consejo_judicatura === true,
  antecedentesPenales: estudiante.antecedentes_penales === 1 || estudiante.antecedentes_penales === "1" || estudiante.antecedentes_penales === true,
  toxicologico: estudiante.toxicologico === 1 || estudiante.toxicologico === "1" || estudiante.toxicologico === true,
  psicologicoClinico: estudiante.psicologico_clinico === 1 || estudiante.psicologico_clinico === "1" || estudiante.psicologico_clinico === true,
  biometricoPn: estudiante.biometrico_pn === 1 || estudiante.biometrico_pn === "1" || estudiante.biometrico_pn === true,
  educacionGeneralHistorial: normalizeEducacionHistorial(estudiante.educacion_general_historial),
  experienciaHistorial: normalizeExperienciaHistorial(estudiante.experiencia_historial),
});

export const normalizeDocumento = (doc = {}) => ({
  id: doc.id,
  tipo: doc.tipo_documento || doc.tipo || "",
  nombre: doc.nombre_original || doc.nombre || "",
  tamKb: doc.tamanio_kb || doc.tamKb || 0,
  estado: doc.estado || "pendiente",
  resultadoAntecedentes: doc.resultado_antecedentes || doc.resultadoAntecedentes || null,
  creadoEl: doc.created_at || doc.creadoEl || null,
  // OCR análisis (los campos vienen como analisis_*_actual desde listDocumentosForAdminReview)
  decisionAnalisis: doc.analisis_decision_actual || doc.decision_analisis || doc.decisionAnalisis || null,
  analisisRiesgo:   doc.analisis_riesgo_actual   || doc.analisis_riesgo   || doc.analisisRiesgo   || null,
  analisisEstado:   doc.analisis_estado_actual   || doc.analisis_estado   || doc.analisisEstado   || null,
  analisisScore:    doc.analisis_score_actual     ?? doc.analisisScore     ?? null,
});

export const nombreCompleto = (estudiante) =>
  [estudiante?.nombres, estudiante?.apellidos].filter(Boolean).join(" ").trim();
